// Swiper Slideshow Component - extends base with slideshow features
class SwiperSlideshow extends SwiperBase {
  constructor(element) {
    super(element);
    this.init();
  }

  // Apply slideshow-specific features to base config
  applyFeatures(config, swiperEl) {
    // Get slideshow settings
    const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
    const speed = (parseInt(swiperEl.dataset.speed) || 4) * 1000; // Convert seconds to milliseconds
    const visual = swiperEl.dataset.visual || 'counter';

    // Add autoplay if enabled
    if (autoplayEnabled) {
      config.autoplay = {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    // Configure pagination based on visual mode
    if (visual === 'dots') {
      config.pagination.type = 'bullets';
    } else if (visual === 'numbers') {
      config.pagination.type = 'bullets';
      config.pagination.renderBullet = this.renderNumberBullet;
    }
    // counter mode uses default fraction from base

    // Add slideshow-specific callbacks
    const originalCallbacks = config.on || {};
    config.on = {
      ...originalCallbacks,
      init: (swiper) => {
        originalCallbacks.init?.(swiper);
        this.setupAutoplayToggle(swiper);
      },
      autoplayStop: () => {},
      autoplayStart: () => {},
      transitionEnd: (swiper) => {
        // Theme editor compatibility
        if (window.Shopify?.designMode) {
          // Handle theme editor updates
        }
      }
    };
  }

  renderNumberBullet(index, className) {
    return `<span class="${className}">${index + 1}</span>`;
  }

  setupAutoplayToggle(swiper) {
    const autoplayButton = swiper.el.querySelector('.swiper-autoplay-toggle');

    if (autoplayButton && swiper.autoplay) {
      autoplayButton.addEventListener('click', () => {
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
          autoplayButton.classList.add('slideshow__autoplay--paused');
          autoplayButton.setAttribute('aria-label', window.accessibilityStrings?.playSlideshow || 'Play slideshow');
        } else {
          swiper.autoplay.start();
          autoplayButton.classList.remove('slideshow__autoplay--paused');
          autoplayButton.setAttribute('aria-label', window.accessibilityStrings?.pauseSlideshow || 'Pause slideshow');
        }
      });
    }
  }

  onSwiperInit(swiper) {
    super.onSwiperInit(swiper);
  }

  onSlideChange(swiper) {
    super.onSlideChange(swiper);
    // Slideshow-specific slide change logic if needed
  }
}

// Function to initialize slideshow wrappers
function initializeSlideshowWrappers() {
  const swiperSlideshows = document.querySelectorAll('.swiper-slideshow-wrapper');

  swiperSlideshows.forEach((slideshow) => {
    // Skip if already initialized
    if (slideshow.dataset.swiperInitialized) return;

    const swiperEl = slideshow.querySelector('.swiper');
    if (swiperEl) {
      // Mark as initialized to prevent double-initialization
      slideshow.dataset.swiperInitialized = 'true';
      new SwiperSlideshow(slideshow);
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Initial check for existing slideshow wrappers
  initializeSlideshowWrappers();

  // Watch for product-recommendations that load content dynamically
  const productRecommendations = document.querySelectorAll('product-recommendations');

  productRecommendations.forEach((productRec) => {
    // Watch for when content gets loaded
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Small delay to ensure DOM is fully updated
          setTimeout(() => {
            initializeSlideshowWrappers();
          }, 100);
        }
      });
    });

    observer.observe(productRec, {
      childList: true,
      subtree: true
    });
  });
});

// Theme editor compatibility
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const swiperSlideshows = event.target.querySelectorAll('.swiper-slideshow-wrapper');
    swiperSlideshows.forEach(slideshow => {
      new SwiperSlideshow(slideshow);
    });
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const swiperSlideshows = event.target.querySelectorAll('.swiper-slideshow-wrapper');
    swiperSlideshows.forEach(slideshow => {
      const swiperEl = slideshow.querySelector('.swiper');
      if (swiperEl && swiperEl.swiperInstance) {
        swiperEl.swiperInstance.destroy();
      }
    });
  });
}